<template>
  <div class="d-flex align-items-center quantity-clicker">
    <button class="btn"
            @click="minus">
      <MinusSvg :class="{
        'svg-gray': minusDisabled,
        'svg-primary': !minusDisabled
      }"/>
    </button>
    <span  v-if="!manualEditing"
           :class="{ 'text-underlined': !readonly }"
           class="word-break"
           @click.stop="startManualEditing">{{ formatNumber(amount, true, '0') }}</span>
    <input type="number"
           style="width: 60px"
           class="form-control sm d-inline-block align-middle"
           ref="valueEditRef"
           @keyup.enter="clickOutside"
           @keyup.esc="cancelManualEdit"
           v-click-outside="clickOutside"
           @change="manualChanged"
           v-model="amountManual"
           v-if="manualEditing"/>
    <button class="btn"
            @click="plus">
      <PlusSvg :class="{ 'svg-gray': readonly, 'svg-primary': !readonly }"/>
    </button>
  </div>
</template>

<script setup>
import MinusSvg from "@/assets/svg-vue/services/minus_service.svg"
import PlusSvg from "@/assets/svg-vue/services/plus_service.svg"
import {computed, nextTick, onMounted, ref, watch} from "vue"
import {formatNumber} from "@/extensions/filters/filters"

const props = defineProps({
  readonly: Boolean,
  amount: Number,
})

const justOpened = ref(false)

const valueEditRef = ref(null)
const manualEditing = ref(false)
const amountManual = ref(0)
const originalValue = ref(0)

const emit = defineEmits([
  'amount',
  'minus',
  'plus'
])

const processJustOpened = () => {
  justOpened.value = true
  setTimeout(() => justOpened.value = false, 100)
}

const minusDisabled = computed(() => props.amount <= 0 || props.readonly)

const minus = () => {
  if(props.readonly) return
  emit('minus')
}

const plus = () => {
  if(props.readonly) return
  emit('plus')
}

const startManualEditing = async () => {
  if(props.readonly) return
  manualEditing.value = true
  processJustOpened()
  await nextTick()
  valueEditRef.value?.focus()
  originalValue.value = amountManual.value
}

const clickOutside = () => {
  if(justOpened.value) return
  manualEditing.value = false
}

const manualChanged = () => {
  // emit('amount', val?.target?.value || 0)
  emit('amount', amountManual.value || 0)
}

const cancelManualEdit = () => {
  amountManual.value = originalValue.value
  clickOutside()
}

onMounted(() => {
  amountManual.value = props.amount
})

watch(() => props.amount, (val) => {
  amountManual.value = val
})
</script>


<style scoped lang="scss">
.quantity-clicker {
  button {
    box-shadow: none !important;
    outline: none;
    display: inline-flex;
    min-height: 24px;
    height: 100%;
    align-items: center;
    padding: 0 6px;
    cursor: pointer;
    svg {
      pointer-events: none;
    }
  }
}
</style>
